module.exports = __webpack_public_path__ + "img/wx_account.406346d1.png";